var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.visible,
            title: _vm.$t("SeaExport.DoorAddress"),
            width: "1000px",
            "close-on-click-modal": false,
            "append-to-body": ""
          },
          on: {
            closed: _vm.handleClose,
            "update:visible": function(val) {
              return _vm.$emit("update:visible", val)
            }
          }
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  staticStyle: { width: "100%", "margin-bottom": "5px" },
                  attrs: { "label-width": "60px", "label-position": "left" }
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 5 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_AuthorizedClient")
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.site.companyName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.site, "companyName", $$v)
                                  },
                                  expression: "site.companyName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("Partners.doorName") } },
                            [
                              _c("el-input", {
                                attrs: { clearable: "" },
                                model: {
                                  value: _vm.filter.name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filter, "name", $$v)
                                  },
                                  expression: "filter.name"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("Payment.contactPerson") }
                            },
                            [
                              _c("el-input", {
                                attrs: { clearable: "" },
                                model: {
                                  value: _vm.filter.contact,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filter, "contact", $$v)
                                  },
                                  expression: "filter.contact"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("SeaExport.Tel") } },
                            [
                              _c("el-input", {
                                attrs: { clearable: "" },
                                model: {
                                  value: _vm.filter.phone,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filter, "phone", $$v)
                                  },
                                  expression: "filter.phone"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("Partners.detailAddress") }
                            },
                            [
                              _c("el-input", {
                                attrs: { clearable: "" },
                                model: {
                                  value: _vm.filter.address,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filter, "address", $$v)
                                  },
                                  expression: "filter.address"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  !_vm.showArea
                    ? _c(
                        "el-row",
                        { attrs: { gutter: 10 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 5 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("CargoMsg.Cargo_CityP")
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: { clearable: "" },
                                    model: {
                                      value: _vm.filter.city,
                                      callback: function($$v) {
                                        _vm.$set(_vm.filter, "city", $$v)
                                      },
                                      expression: "filter.city"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 4 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: _vm.$t("Payment.remarks") } },
                                [
                                  _c("el-input", {
                                    attrs: { clearable: "" },
                                    model: {
                                      value: _vm.filter.remarks,
                                      callback: function($$v) {
                                        _vm.$set(_vm.filter, "remarks", $$v)
                                      },
                                      expression: "filter.remarks"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                { staticClass: "operation-buttons" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function($event) {
                                          _vm.filter.pageNum = 1
                                          _vm.handleSearch()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("CargoMsg.Cargo_Query"))
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-button",
                                    { on: { click: _vm.resetFilter } },
                                    [_vm._v(_vm._s(_vm.$t("common.btn.reset")))]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.showArea
                    ? _c(
                        "el-row",
                        { attrs: { gutter: 10 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 5 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: _vm.$t("Payment.remarks") } },
                                [
                                  _c("el-input", {
                                    attrs: { clearable: "" },
                                    model: {
                                      value: _vm.filter.remarks,
                                      callback: function($$v) {
                                        _vm.$set(_vm.filter, "remarks", $$v)
                                      },
                                      expression: "filter.remarks"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 16 } },
                            [
                              _c(
                                "el-form",
                                {
                                  attrs: {
                                    inline: "",
                                    "label-position": "left"
                                  }
                                },
                                [
                                  _c("cargo-area", {
                                    ref: "filterArea",
                                    attrs: {
                                      no: "filterArea",
                                      filterable: "",
                                      "allow-create": false,
                                      country: "CN",
                                      province: _vm.filter.province,
                                      city: _vm.filter.cityNew,
                                      district: _vm.filter.county,
                                      town: _vm.filter.town,
                                      "district-label-name": _vm.$t(
                                        "CargoMsg.Cargo_CountyDistrict"
                                      ),
                                      "town-label-name": _vm.$t(
                                        "CargoMsg.Cargo_TownStreet"
                                      ),
                                      "town-style": { marginRight: 0 },
                                      placeholder: " ",
                                      "label-width": "60",
                                      "show-town": true,
                                      "select-width": 95
                                    },
                                    on: {
                                      "update:province": function($event) {
                                        return _vm.$set(
                                          _vm.filter,
                                          "province",
                                          $event
                                        )
                                      },
                                      "update:city": function($event) {
                                        return _vm.$set(
                                          _vm.filter,
                                          "cityNew",
                                          $event
                                        )
                                      },
                                      "update:district": function($event) {
                                        return _vm.$set(
                                          _vm.filter,
                                          "county",
                                          $event
                                        )
                                      },
                                      "update:town": function($event) {
                                        return _vm.$set(
                                          _vm.filter,
                                          "town",
                                          $event
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.showArea
                    ? _c(
                        "el-row",
                        { attrs: { gutter: 10 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 21 } },
                            [
                              _c(
                                "el-form-item",
                                { staticClass: "operation-buttons" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function($event) {
                                          _vm.filter.pageNum = 1
                                          _vm.handleSearch()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("CargoMsg.Cargo_Query"))
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-button",
                                    { on: { click: _vm.resetFilter } },
                                    [_vm._v(_vm._s(_vm.$t("common.btn.reset")))]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c("div", { staticClass: "main-content" }, [
                _c(
                  "div",
                  {
                    staticClass: "operations",
                    staticStyle: { "margin-bottom": "5px" }
                  },
                  [
                    _c("div", { staticClass: "triggers" }, [
                      _c(
                        "div",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                no: "new",
                                disabled: !_vm.isEdit,
                                type: "primary"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.showEditDialog(true)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                no: "edit",
                                disabled: !_vm.isEdit,
                                type: "primary"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.showEditDialog(false)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { disabled: !_vm.isEdit, type: "danger" },
                              on: { click: _vm.remove }
                            },
                            [_vm._v(_vm._s(_vm.$t("common.btn.delete")))]
                          )
                        ],
                        1
                      )
                    ])
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "grid-wrapper" },
                  [
                    _c("cargo-ag-grid", {
                      staticStyle: { width: "100%", "min-height": "300px" },
                      attrs: {
                        "grid-params": _vm.girdParams,
                        "grid-options": _vm.gridOptions,
                        "column-defs": _vm.columnDefs,
                        "row-data": _vm.rowData
                      },
                      on: {
                        "update:gridParams": function($event) {
                          _vm.girdParams = $event
                        },
                        "update:grid-params": function($event) {
                          _vm.girdParams = $event
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "pagination-container" },
                  [
                    _c("cargo-pagination", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.total > 0,
                          expression: "total>0"
                        }
                      ],
                      attrs: {
                        page: _vm.filter.pageNum,
                        limit: _vm.filter.pageSize,
                        total: _vm.total
                      },
                      on: {
                        "update:page": function($event) {
                          return _vm.$set(_vm.filter, "pageNum", $event)
                        },
                        "update:limit": function($event) {
                          return _vm.$set(_vm.filter, "pageSize", $event)
                        },
                        pagination: _vm.handleSearch
                      }
                    }),
                    _c(
                      "el-button",
                      {
                        staticClass: "close-btn",
                        on: { click: _vm.handleCancel }
                      },
                      [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
                    )
                  ],
                  1
                )
              ]),
              _c(
                "el-dialog",
                {
                  directives: [
                    { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
                  ],
                  attrs: {
                    visible: _vm.editDialog.visible,
                    title: _vm.editDialog.title,
                    width: "400px",
                    "close-on-click-modal": false,
                    "append-to-body": ""
                  },
                  on: {
                    "update:visible": function($event) {
                      return _vm.$set(_vm.editDialog, "visible", $event)
                    }
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "app-main-inner-row",
                      staticStyle: { "padding-bottom": "10px" }
                    },
                    [
                      _c(
                        "el-form",
                        {
                          attrs: {
                            "label-width": "100px",
                            "label-position": "left"
                          }
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("Partners.doorName") } },
                            [
                              _c("el-input", {
                                attrs: { no: "name" },
                                model: {
                                  value: _vm.editDialog.form.name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editDialog.form, "name", $$v)
                                  },
                                  expression: "editDialog.form.name"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("Payment.contactPerson") }
                            },
                            [
                              _c("el-input", {
                                attrs: { no: "contact" },
                                model: {
                                  value: _vm.editDialog.form.contact,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.editDialog.form,
                                      "contact",
                                      $$v
                                    )
                                  },
                                  expression: "editDialog.form.contact"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("SeaExport.Tel") } },
                            [
                              _c("el-input", {
                                attrs: { no: "phone" },
                                model: {
                                  value: _vm.editDialog.form.phone,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editDialog.form, "phone", $$v)
                                  },
                                  expression: "editDialog.form.phone"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("Partners.detailAddress") }
                            },
                            [
                              _c("el-input", {
                                attrs: { no: "address" },
                                model: {
                                  value: _vm.editDialog.form.address,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.editDialog.form,
                                      "address",
                                      $$v
                                    )
                                  },
                                  expression: "editDialog.form.address"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("Payment.remarks") } },
                            [
                              _c("el-input", {
                                attrs: { no: "remarks" },
                                model: {
                                  value: _vm.editDialog.form.remarks,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.editDialog.form,
                                      "remarks",
                                      $$v
                                    )
                                  },
                                  expression: "editDialog.form.remarks"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.showArea,
                                  expression: "!showArea"
                                }
                              ],
                              attrs: { label: _vm.$t("CargoMsg.Cargo_CityP") }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  no: "city",
                                  cache: false,
                                  filterable: "",
                                  "default-value": _vm.editDialog.form.city,
                                  "tag-name":
                                    this.$store.getters.language === "zh"
                                      ? "chineseName"
                                      : "englishName",
                                  "tag-value": "code",
                                  placeholder: " ",
                                  "static-options": _vm.locationList
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.editDialog.form.city = p.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("SeaExport.ZIP") } },
                            [
                              _c("el-input", {
                                attrs: { no: "zipCode" },
                                model: {
                                  value: _vm.editDialog.form.zipCode,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.editDialog.form,
                                      "zipCode",
                                      $$v
                                    )
                                  },
                                  expression: "editDialog.form.zipCode"
                                }
                              })
                            ],
                            1
                          ),
                          _c("cargo-area", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showArea,
                                expression: "showArea"
                              }
                            ],
                            ref: "area",
                            staticStyle: { display: "inline-block" },
                            attrs: {
                              no: "area",
                              country: _vm.editDialog.form.country,
                              province: _vm.editDialog.form.province,
                              city: _vm.editDialog.form.cityNew,
                              district: _vm.editDialog.form.county,
                              town: _vm.editDialog.form.town,
                              "district-label-name": _vm.$t(
                                "CargoMsg.Cargo_CountyDistrict"
                              ),
                              "town-label-name": _vm.$t(
                                "CargoMsg.Cargo_TownStreet"
                              ),
                              "label-width": "100",
                              "select-width": 280,
                              "show-town": true
                            },
                            on: {
                              "update:country": function($event) {
                                return _vm.$set(
                                  _vm.editDialog.form,
                                  "country",
                                  $event
                                )
                              },
                              "update:province": function($event) {
                                return _vm.$set(
                                  _vm.editDialog.form,
                                  "province",
                                  $event
                                )
                              },
                              "update:city": function($event) {
                                return _vm.$set(
                                  _vm.editDialog.form,
                                  "cityNew",
                                  $event
                                )
                              },
                              "update:district": function($event) {
                                return _vm.$set(
                                  _vm.editDialog.form,
                                  "county",
                                  $event
                                )
                              },
                              "update:town": function($event) {
                                return _vm.$set(
                                  _vm.editDialog.form,
                                  "town",
                                  $event
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "span",
                    { attrs: { slot: "footer" }, slot: "footer" },
                    [
                      _vm.showArea
                        ? _c(
                            "el-button",
                            {
                              staticStyle: {
                                height: "32px",
                                margin: "4px 10px 0 0"
                              },
                              attrs: {
                                no: "aiRecognitionRegion",
                                type: "primary",
                                size: "mini"
                              },
                              on: { click: _vm.openAiRegionRecognition }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "CargoMsg.CargoMsg_AIAddressRecognition"
                                  )
                                )
                              )
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "el-button",
                        {
                          attrs: { no: "save", type: "primary" },
                          on: { click: _vm.saveSub }
                        },
                        [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { no: "cancel" },
                          on: {
                            click: function($event) {
                              _vm.editDialog.visible = false
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ]
      ),
      _c("cargo-ai-recognition-dialog", {
        attrs: {
          visible: _vm.aiRecognitionDialog.visible,
          multimodal: _vm.aiRecognitionDialog.multimodal,
          "prompt-key": _vm.aiRecognitionDialog.promptKey,
          "call-back": _vm.aiRecognitionDialog.callBack,
          title: _vm.$t("CargoMsg.CargoMsg_AIAddressRecognition"),
          placeholder: _vm.aiRecognitionDialog.placeholder
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.aiRecognitionDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }